/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TimeStepSettings
 */
export interface TimeStepSettings {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulationId?: number;
  /**
   * Size of the simulation time step in seconds.
   */
  timeStep: number;
  /**
   * Minimum size of the simulation time step in seconds. Suitable default is 0.001.
   */
  minTimeStep: number;
  /**
   * Only in combination with use_time_step_stretch=True.
   */
  maxTimeStep?: number | null;
  /**
   * Permit the time step to increase automatically, when the flow allows it.
   */
  useTimeStepStretch: boolean;
  /**
   * The interval in seconds in which results are saved to disk.
   */
  outputTimeStep?: number | null;
}

/**
 * Check if a given object implements the TimeStepSettings interface.
 */
export function instanceOfTimeStepSettings(value: object): value is TimeStepSettings {
  if (
    (!("timeStep" in (value as Record<string, any>)) &&
      !("time_step" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["timeStep"] === undefined &&
      (value as Record<string, any>)["time_step"] === undefined)
  )
    return false;
  if (
    (!("minTimeStep" in (value as Record<string, any>)) &&
      !("min_time_step" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["minTimeStep"] === undefined &&
      (value as Record<string, any>)["min_time_step"] === undefined)
  )
    return false;
  if (
    (!("useTimeStepStretch" in (value as Record<string, any>)) &&
      !("use_time_step_stretch" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["useTimeStepStretch"] === undefined &&
      (value as Record<string, any>)["use_time_step_stretch"] === undefined)
  )
    return false;
  return true;
}

export function TimeStepSettingsFromJSON(json: any): TimeStepSettings {
  return TimeStepSettingsFromJSONTyped(json, false);
}

export function TimeStepSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimeStepSettings {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulationId: json["simulation_id"] == null ? undefined : json["simulation_id"],
    timeStep: json["time_step"],
    minTimeStep: json["min_time_step"],
    maxTimeStep:
      json["max_time_step"] === undefined
        ? undefined
        : json["max_time_step"] === null
        ? null
        : json["max_time_step"],
    useTimeStepStretch: json["use_time_step_stretch"],
    outputTimeStep:
      json["output_time_step"] === undefined
        ? undefined
        : json["output_time_step"] === null
        ? null
        : json["output_time_step"],
  };
}

export function TimeStepSettingsToJSON(json: any): TimeStepSettings {
  return TimeStepSettingsToJSONTyped(json, false);
}

export function TimeStepSettingsToJSONTyped(
  value?: Omit<TimeStepSettings, "id" | "simulationId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    time_step: value["timeStep"],
    min_time_step: value["minTimeStep"],
    max_time_step: value["maxTimeStep"],
    use_time_step_stretch: value["useTimeStepStretch"],
    output_time_step: value["outputTimeStep"],
  };
}
